import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface FraudFlagReasonDialogProps {
  showReasonDialog: boolean
  pendingValue: boolean
  displayName: string
  isUpdatingFlag: boolean
  reason: string
  setReason: (value: string) => void
  handleConfirmToggle: () => Promise<void>
  handleCancelToggle: () => void
}


export const FraudFlagReasonDialog: React.FC<FraudFlagReasonDialogProps> = ({
  showReasonDialog,
  pendingValue,
  displayName,
  isUpdatingFlag,
  reason,
  setReason,
  handleConfirmToggle,
  handleCancelToggle, }
) => {
  const { t } = useTranslation()

  return (
    <>
      <Dialog open={showReasonDialog} onClose={handleCancelToggle} maxWidth="sm" fullWidth>
        <DialogTitle>{pendingValue ? t('fraudFlags.activateFlag') : t('fraudFlags.deactivateFlag')}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {t('fraudFlags.confirmToggle', { flag: displayName })}
          </Typography>
          <TextField
            autoFocus
            required
            margin="dense"
            label={t('fraudFlags.reason')}
            fullWidth
            multiline
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t('fraudFlags.reasonPlaceholder')}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelToggle} disabled={isUpdatingFlag}>
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleConfirmToggle}
            variant="contained"
            disabled={!reason.trim()}
            loading={isUpdatingFlag}
            loadingPosition="start"
          >
            {t('common.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )  
}